import { gql } from 'graphql-request'

export const RESET_PASSWORD = gql`
  mutation ResetPassword($resetPwdInput: ResetPwdInput!) {
    resetPassword(resetPwdInput: $resetPwdInput) {
      message
    }
  }
`
